if (!customElements.get('lace-cart-add')) {
  customElements.define(
    'lace-cart-add',
    class LaceCartAdd extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('[data-lace-add]');
        if (!button || button.dataset.laceBound === '1') return;
        button.dataset.laceBound = '1';
        button.addEventListener('click', this.onAdd.bind(this));
      }

      onAdd(event) {
        event.preventDefault();
        event.stopPropagation();
        const button = event.currentTarget;
        const variantId = button.getAttribute('data-variant-id');
        if (!variantId || button.getAttribute('aria-disabled') === 'true') return;

        const drawer = document.querySelector('cart-drawer');
        const cartItems = document.querySelector('cart-items');
        const sections = [];
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          drawer.getSectionsToRender().forEach((section) => sections.push(section.id));
        } else if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
          cartItems.getSectionsToRender().forEach((section) => sections.push(section.section));
        }

        button.setAttribute('aria-disabled', 'true');
        const body = {
          id: variantId,
          quantity: 1,
        };
        if (sections.length) {
          body.sections = sections;
          body.sections_url = window.location.pathname;
        }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((state) => {
            if (state.status) {
              button.removeAttribute('aria-disabled');
              return;
            }
            if (drawer && state.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(state);
              return;
            }
            if (cartItems && state.sections && typeof cartItems.getSectionsToRender === 'function') {
              cartItems.classList.toggle('is-empty', state.item_count === 0);
              cartItems.getSectionsToRender().forEach((section) => {
                const root = document.getElementById(section.id);
                if (!root) return;
                const target = root.querySelector(section.selector) || root;
                const html = new DOMParser().parseFromString(state.sections[section.section], 'text/html');
                const source = html.querySelector(section.selector) || html.querySelector('.shopify-section');
                if (source) target.innerHTML = source.innerHTML;
              });
              return;
            }
            window.location.href = window.routes.cart_url;
          })
          .catch(() => {
            button.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
